import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    root: {},
    paper: {
      borderRadius: spacing(3),
      margin: spacing(8),
      width: `calc(100% - ${spacing(16)}px)`,

      [breakpoints.down('xs')]: {
        margin: spacing(4),
        minWidth: 'auto',
        width: `calc(100% - ${spacing(8)}px)`,
      },
    },
  });
